import type { ApprovalStage, TimeOffRequest } from '../domain/timeoff'

const getApprovalStage = (request: TimeOffRequest): ApprovalStage => {
	if (request.deptApproval.status === 'rejected' || request.hrApproval.status === 'rejected') return 'rejected'
	if (request.deptApproval.status === 'approved' && request.hrApproval.status === 'approved') return 'approved'
	if (request.deptApproval.status === 'approved' && request.hrApproval.status === 'pending') return 'pending_hr'
	return 'pending_dept'
}

export { getApprovalStage }
